import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewsletterLandingPageComponent } from './newsletter-landing-page.component';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [{ path: ':contentId', component: NewsletterLandingPageComponent }];
@NgModule({
  declarations: [NewsletterLandingPageComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule,
    NewsletterLandingPageComponent
  ]
})
export class NewsletterLandingPageModule { }
